import { render, staticRenderFns } from "./included.vue?vue&type=template&id=510b974c&scoped=true&"
import script from "./included.vue?vue&type=script&lang=js&"
export * from "./included.vue?vue&type=script&lang=js&"
import style0 from "./included.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./included.vue?vue&type=style&index=1&id=510b974c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b974c",
  null
  
)

export default component.exports